import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Icon-people",
  "use": "icon-Icon-people-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-Icon-people\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.928 2a2.361 2.361 0 0 0-2.335 2.714L5.79 6.02a2.157 2.157 0 0 0 4.264.015l.206-1.304A2.361 2.361 0 0 0 7.928 2ZM3.896 9.775A2.856 2.856 0 0 0 2.228 11.7l-.117.451a.948.948 0 0 0 .918 1.184h9.965a.948.948 0 0 0 .918-1.184l-.117-.45a2.856 2.856 0 0 0-1.668-1.926 10.71 10.71 0 0 0-8.23 0Z\" fill=\"#7F8596\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol